// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
require('./_set-collection-of')('WeakMap');



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/es7.weak-map.of.js
 ** module id = 860
 ** module chunks = 0
 **/